import { render, staticRenderFns } from "./HomeType.vue?vue&type=template&id=4c7cbcf3&"
import script from "./HomeType.vue?vue&type=script&lang=js&"
export * from "./HomeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports